// @need-translate
import { Request } from 'express';
import { ReactElement } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { getDehydratedState } from '../../../common/getDehydrateState';
import { tt } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import PageLayout from '../../../domain/landing/presentational';
import { addError } from '../../../errors/ErrorSlice';
import { thunkSerializeError } from '../../../errors/thunkSerializeError.function';
import { StaticLandingGenreLayoutQuery, StaticLandingGenreLayoutQueryVariables, StaticLandingGenreSection, StaticLandingType } from '../../../graphql/generated/types';
import { CommonMobileHeaderType } from '../../../header/constants';
import { PageViewCustomPropsDataKey } from '../../../logging/PageViewCustomPropsDataKey.enum';
import { setLayout } from '../../../pagewebLayout/PagewebLayoutSlice';
import { nextReduxWrapper } from '../../../state/store';
import { STATIC_LANDING_PAGE_NAME_MAP, STATIC_LANDING_PAGE_SECTION_NAME } from '../../../staticLanding/constants';
import { STATIC_LANDING_GENRE_CATEGORY_LIST } from '../../../staticLanding/genre/constants';
import { queryStaticLandingLayout } from '../../../staticLanding/queryStaticLandingLayout';
function StaticLandingGenre({
  layoutId,
  categoryName
}: {
  layoutId: string;
  categoryName: string;
}) {
  return <>
      <PageLayout id={layoutId} />
      <TrackPageViewContainer trackObj={{
      section: STATIC_LANDING_PAGE_SECTION_NAME,
      page: `${STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.Genre]}_${categoryName}`,
      actionType: 'Pageview',
      actionName: `${STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.Genre]}_화면`,
      customProps: {
        user_action: 'pv'
      }
    }} customPropsDataKeyList={[PageViewCustomPropsDataKey.PageGenreFilter, PageViewCustomPropsDataKey.PageSort, PageViewCustomPropsDataKey.Completed]} />
    </>;
}
StaticLandingGenre.getInitialProps = nextReduxWrapper.getInitialPageProps(store => async context => {
  const cookie = context?.req?.headers.cookie;
  const uidInfoList = context.query?.pathParams as string[];
  const query = context?.query;
  if (!uidInfoList || uidInfoList.length === 0) {
    return {
      notFound: true
    };
  }
  try {
    const {
      data,
      queryClient
    } = await queryStaticLandingLayout<StaticLandingGenreLayoutQuery, StaticLandingGenreLayoutQueryVariables>({
      ssrRequest: context.req as Request,
      type: StaticLandingType.Genre,
      cookie,
      uidInfoList,
      query
    });
    if (!data || !data.staticLandingGenreLayout) {
      throw new Error('genre 레이아웃 데이터가 없습니다');
    }
    const layoutId = data.staticLandingGenreLayout.id;
    // redux에 레이아웃 정보가 없을 때만 setLayout으로 값을 초기화 해줍니다.
    if (!store.getState().pagewebLayout.entities.layouts[layoutId]) {
      store.dispatch(setLayout({
        layout: data.staticLandingGenreLayout
      }));
    }
    const staticLandingGenreSection = data.staticLandingGenreLayout.sections[0] as StaticLandingGenreSection;
    const title = staticLandingGenreSection.title ?? '장르 전체';
    const categoryUid = staticLandingGenreSection.param.categoryUid;
    const isComplete = staticLandingGenreSection.param.isComplete;
    const category = STATIC_LANDING_GENRE_CATEGORY_LIST.find(categoryInfo => categoryInfo.id === categoryUid);
    return {
      layoutId: data.staticLandingGenreLayout.id,
      title,
      categoryName: tt(category),
      subcategoryName: staticLandingGenreSection.param.subcategory?.name,
      sortTypeName: staticLandingGenreSection.param.sortType?.name,
      isComplete,
      ...getDehydratedState(queryClient)
    };
  } catch (error) {
    store.dispatch(addError({
      error: thunkSerializeError(error)
    }));
    return {};
  }
});
StaticLandingGenre.getLayout = function getLayout(page: ReactElement) {
  const {
    subcategoryName,
    sortTypeName,
    isComplete
  } = page.props;
  return <Layout title={page.props.title} mobileLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true,
    headerType: CommonMobileHeaderType.TwoDepth,
    headerCustomTiaraObject: {
      customProps: {
        page_genre_filter: subcategoryName,
        page_sort: sortTypeName,
        completed: isComplete ? 'y' : 'n'
      }
    }
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true
  }}>
      {page}
    </Layout>;
};
export default StaticLandingGenre;